import { getConflictingCombinations } from './getConflictingCombinations';
import { TableRes } from '../../../shared/types';
import HtzBauteilIndexConflictTable from '../components/HtzBauteilIndexConflictTable';

export type RowsProps = {
  add: any[];
  edit: any[];
  editRowOriginal: Record<string, any>;
};

export type ConfirmBeforeCommitResult = {
  shouldOpenConfirmation: boolean;
  confirmationProps?: {
    title?: string;
    confirmLabel?: string;
    cancelLabel?: string;
    children?: React.ReactNode;
  };
};

export async function NpiSteeringConfirmBeforeCommit(
  rowsProps: RowsProps,
  tableDetails?: TableRes,
): Promise<ConfirmBeforeCommitResult> {
  const screenId = tableDetails?.id;
  const addedRows = Array.isArray(rowsProps?.add) ? rowsProps.add : [];

  if (addedRows.length === 0 || !screenId) {
    return { shouldOpenConfirmation: false };
  }

  const pairs = addedRows
    .map((r) => ({ htz: r?.htz, bauteilindex: r?.bauteilindex }))
    .filter((p) => p.htz && p.bauteilindex);

  if (pairs.length === 0) {
    return { shouldOpenConfirmation: false };
  }

  try {
    const conflicts = await getConflictingCombinations(pairs, screenId, tableDetails);

    const shouldOpenConfirmation = Array.isArray(conflicts) && conflicts.length > 0;

    return {
      shouldOpenConfirmation,
      confirmationProps: shouldOpenConfirmation
        ? {
            title: 'npiSteering.htz_part_index_exists_confirmation',
            confirmLabel: 'save_anyway',
            cancelLabel: 'cancel',
            children: (
              <HtzBauteilIndexConflictTable
                rows={conflicts.map((row: any) => ({
                  htz: row.htz,
                  bauteilindex: row.bauteilindex,
                }))}
              />
            ),
          }
        : undefined,
    };
  } catch {
    return { shouldOpenConfirmation: false };
  }
}
